import React from 'react';

const PushNotifications = () => {
  return <div>PushNotifications</div>;
};

export default PushNotifications;
